import script from "./school_Journalism.vue?vue&type=script&setup=true&lang=js"
export * from "./school_Journalism.vue?vue&type=script&setup=true&lang=js"

import "./school_Journalism.vue?vue&type=style&index=0&id=7f933a7b&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f933a7b"]])

export default __exports__